// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.full-width-search[data-v-2dc45ae1] {\n    width: 100%;\n}\n.avatar-clickthrough[data-v-2dc45ae1] {\n    pointer-events: none;\n}\n.staging-banner[data-v-2dc45ae1] {\n    color: #fff;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n.staging-banner__separator[data-v-2dc45ae1] {\n    margin: 0 8px;\n    opacity: 0.5;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
